"use client";

import Button from "./Button";
import Typography from "./Typography";

type YouTubeReconnectDialogProps = {
  onReconnect: () => void;
  onCancel: () => void;
  isConnecting?: boolean;
};

/** Cancel owns dismissal, so the surrounding Dialog hides its close icon. */
export default function YouTubeReconnectDialog({
  onReconnect,
  onCancel,
  isConnecting = false,
}: YouTubeReconnectDialogProps) {
  return (
    <div data-owns-dialog-close className="flex flex-col text-start">
      <Typography variant="h5">
        Reconnect YouTube
      </Typography>
      <Typography variant="body2" className="mt-2 text-foreground-secondary">
        Please reconnect your account to continue publishing.
      </Typography>
      <div className="flex items-center justify-end gap-2 pt-6">
        <Button
          type="button"
          variant="secondary"
          size="m"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          type="button"
          autoFocus
          variant="primary"
          size="m"
          onClick={onReconnect}
          disabled={isConnecting}
          loading={isConnecting}
          loadingLabel="Reconnecting..."
          aria-busy={isConnecting}
        >
          Reconnect YouTube
        </Button>
      </div>
    </div>
  );
}
